import { z } from "zod";
import { cursorPageSchema } from "./context.js";
import { evidenceReviewStatusSchema } from "./evidence.js";
import { ingestionRunStatusSchema } from "./governance.js";
export const sourceRunObservationDispositionSchema = z.enum(["CREATED", "REUSED"]);
/**
 * Operator-facing source run. `created` and `reused` count immutable receipts
 * for this run only. `contentSha256` on receipts is document identity, never a
 * published tax rate.
 */
export const sourceRunSchema = z
    .object({
    id: z.string().uuid(),
    sourceId: z.string().uuid(),
    revision: z.number().int().positive().optional(),
    status: ingestionRunStatusSchema,
    // No recorded update in 24h; an operator may explicitly cancel the run.
    // This is not a worker lease or evidence that no delivery remains queued.
    stale: z.boolean().optional(),
    startedAt: z.string().datetime(),
    finishedAt: z.string().datetime().nullable(),
    durationMs: z.number().int().nonnegative().nullable(),
    discovered: z.number().int().nonnegative(),
    ingested: z.number().int().nonnegative(),
    failed: z.number().int().nonnegative(),
    correlationId: z.string().min(1),
    message: z.string().min(1).nullable(),
    created: z.number().int().nonnegative(),
    reused: z.number().int().nonnegative(),
})
    .strict();
export const sourceRunEvidenceReceiptSchema = z
    .object({
    evidenceId: z.string().uuid(),
    title: z.string().min(1),
    publisher: z.string().min(1),
    canonicalUrl: z.string().url(),
    reviewStatus: evidenceReviewStatusSchema,
    observedAt: z.string().datetime(),
    disposition: sourceRunObservationDispositionSchema,
    contentSha256: z.string().regex(/^[a-f0-9]{64}$/),
})
    .strict();
export const sourceRunEvidencePageSchema = cursorPageSchema
    .extend({
    items: z.array(sourceRunEvidenceReceiptSchema),
    totalEstimate: z.number().int().nonnegative(),
})
    .strict();
//# sourceMappingURL=source-runs.js.map